import api from '../utils/api';

const ptfaUrl = process.env.REACT_APP_PTFA_URL;

// Function sezione: DPCM
async function getDpcm(limit, offset, filters) {
  let params = '';
  if (filters.sortField) {
    params += `sortField=${filters.sortField}&`;
  }
  if (filters.sortOrder) {
    params += `sortOrder=${filters.sortOrder}&`;
  }
  if (filters.flag_attivo || filters.flag_attivo === false) {
    params += `flag_attivo=${filters.flag_attivo}&`;
  }
  if (offset || offset === 0) {
    params += `offset=${offset}&`;
  }
  if (limit) {
    params += `limit=${limit}&`;
  }
  return api.get(`${ptfaUrl}/dpcm/?${params}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function getDpcmById(idDpcm) {
  return api.get(`${ptfaUrl}/dpcm/${idDpcm}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function modificaDpcm(newDpcm, idDpcm) {
  return api.put(`${ptfaUrl}/dpcm/${idDpcm}`, newDpcm)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function creaDpcm(stateDpcm) {
  return api.post(`${ptfaUrl}/dpcm`, stateDpcm)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

// Function sezione: PROCEDURA
async function getProcedura(limit, offset, filters) {
  let params = '';
  if (filters.fk_sequ_comparto) {
    params += `fk_sequ_comparto=${filters.fk_sequ_comparto}&`;
  }
  if (filters.sortField) {
    params += `sortField=${filters.sortField}&`;
  }
  if (filters.sortOrder) {
    params += `sortOrder=${filters.sortOrder}&`;
  }
  if (filters.flag_attivo || filters.flag_attivo === false) {
    params += `flag_attivo=${filters.flag_attivo}&`;
  }
  if (offset || offset === 0) {
    params += `offset=${offset}&`;
  }
  if (limit) {
    params += `limit=${limit}&`;
  }
  return api.get(`${ptfaUrl}/procedura/?${params}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function creaProcedura(stateProcedura) {
  return api.post(`${ptfaUrl}/procedura`, stateProcedura)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function getProceduraById(idProcedura) {
  return api.get(`${ptfaUrl}/procedura/${idProcedura}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function modificaProcedura(newProcedura, idProcedura) {
  return api.put(`${ptfaUrl}/procedura/${idProcedura}`, newProcedura)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

// Function sezione: AREA
async function getAree(limit, offset, filters) {
  let params = '';
  if (filters.sortField) {
    params += `sortField=${filters.sortField}&`;
  }
  if (filters.sortOrder) {
    params += `sortOrder=${filters.sortOrder}&`;
  }
  if (filters.fk_sequ_comparto) {
    params += `fk_sequ_comparto=${filters.fk_sequ_comparto}&`;
  }
  if (offset || offset === 0) {
    params += `offset=${offset}&`;
  }
  if (limit) {
    params += `limit=${limit}&`;
  }
  return api.get(`${ptfaUrl}/area/?${params}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

// Function sezione: PIANO
async function getPiano(limit, offset, filters) {
  let params = `sortField=${filters.sortField ?? 'anno_riferimento'}&sortOrder=${filters.sortOrder ?? 'desc'}&`;
  if (filters.desc_denominazione) {
    params += `desc_denominazione=${filters.desc_denominazione}&`;
  }
  if (filters.stato) {
    params += `stato=${filters.stato}&`;
  }
  if (filters.comparto) {
    params += `comparto=${filters.comparto}&`;
  }
  if (offset || offset === 0) {
    params += `offset=${offset}&`;
  }
  if (limit) {
    params += `limit=${limit}&`;
  }
  return api.get(`${ptfaUrl}/piano/?${params}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function creaPiano(statePianoPtfa) {
  return api.post(`${ptfaUrl}/piano`, statePianoPtfa)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function getPianoById(idPianoPtfa) {
  return api.get(`${ptfaUrl}/piano/${idPianoPtfa}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function modificaPiano(newStatePianoPtfa, idPianoPtfa) {
  return api.put(`${ptfaUrl}/piano/${idPianoPtfa}`, newStatePianoPtfa)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

// Function sezione: PIANO AMMINISTRAZIONE
async function creaPianoAmministrazione(statePianoAmminPtfa) {
  return api.post(`${ptfaUrl}/piano-amministrazione`, statePianoAmminPtfa)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function getPianoAmminById(idPianoAmminPtfa) {
  return api.get(`${ptfaUrl}/piano-amministrazione/${idPianoAmminPtfa}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function modificaPianoAmministrazione(newStatePianoAmminPtfa, idPianoAmminPtfa) {
  return api.put(`${ptfaUrl}/piano-amministrazione/${idPianoAmminPtfa}`, newStatePianoAmminPtfa)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function uploadPianoAmministrazione(file) {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`${ptfaUrl}/piano-amministrazione/upload-file`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function downloadPianoAmministrazione(fileName) {
  return api.get(`${ptfaUrl}/piano-amministrazione/download-file/${fileName}`, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    responseType: 'blob',
  })
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function deleteFilePianoAmministrazione(fileName) {
  return api.delete(`${ptfaUrl}/piano-amministrazione/delete-file/${fileName}`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function riapriPianoAmministrazione(idPiano) {
  return api.post(`${ptfaUrl}/piano-amministrazione/${idPiano}/riapri`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function getVersioniPianoAmministrazione(idPiano) {
  return api.get(`${ptfaUrl}/piano-amministrazione/${idPiano}/versioni`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

// Function sezione: CONTRATTI
async function getContrattiDisponibili(limit, offset, filters, id_amministrazione) {
  let params = '';
  /* `sortField=${filters.sortField ?? 'desc_contratto'}&sortOrder=${filters.sortOrder ?? 'desc'}&`; */

  if (filters.comparto) {
    params += `comparto=${filters.comparto}&`;
  }
  if (offset || offset === 0) {
    params += `offset=${offset}&`;
  }
  if (limit) {
    params += `limit=${limit}&`;
  }
  if (id_amministrazione) {
    params += `id_amministrazione=${id_amministrazione}&`;
  }
  return api.get(`${ptfaUrl}/contratti-amministrazione/disponibili?${params}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function aggiungiContrattoAmministrazione(fkCodiAmministrazione, fkCodiPtfaContratto) {
  const payload = {
    fk_codi_amministrazione: fkCodiAmministrazione,
    fk_codi_ptfa_contratto: fkCodiPtfaContratto,
  };

  return api.post(`${ptfaUrl}/contratti-amministrazione/crea`, payload)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function modificaContrattoAmministrazione(sequKPtfaAmmContratto, fkCodiAmministrazione, fkCodiPtfaContratto) {
  const payload = {
    fk_codi_amministrazione: fkCodiAmministrazione,
    fk_codi_ptfa_contratto: fkCodiPtfaContratto,
  };

  return api.put(`${ptfaUrl}/contratti-amministrazione/${sequKPtfaAmmContratto}`, payload)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

async function deleteContrattoAmministrazione(sequ_k_ptfa_amm_contratto) {
  return api.delete(`${ptfaUrl}/contratti-amministrazione/${sequ_k_ptfa_amm_contratto}`)
    .then((res) => res && res.data)
    .catch((err) => Promise.reject(err.response));
}

const PtfaService = {
  getDpcm,
  getDpcmById,
  modificaDpcm,
  creaDpcm,
  getProcedura,
  creaProcedura,
  getProceduraById,
  modificaProcedura,
  getAree,
  getPiano,
  creaPiano,
  getPianoById,
  modificaPiano,
  creaPianoAmministrazione,
  getPianoAmminById,
  modificaPianoAmministrazione,
  uploadPianoAmministrazione,
  downloadPianoAmministrazione,
  deleteFilePianoAmministrazione,
  riapriPianoAmministrazione,
  getVersioniPianoAmministrazione,
  getContrattiDisponibili,
  aggiungiContrattoAmministrazione,
  modificaContrattoAmministrazione,
  deleteContrattoAmministrazione,
};

export default PtfaService;
